import { library } from "@fortawesome/fontawesome-svg-core";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import {
  faEnvelope,
  faMapMarkerAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";

library.add(faLinkedin, faGithub, faEnvelope, faMapMarkerAlt, faFileAlt);
